import { defineMessages } from 'react-intl'

const scope = `procurify.platform.iam.feature-sets.ReportAccessView.ReportAccessDetailEmptyState`

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'No {singularSecondaryOrgCategoryLabel} selected',
  },
  content: {
    id: `${scope}.content`,
    defaultMessage:
      'Select a {singularSecondaryOrgCategoryLabel} to manage who can view its data in their spending reports.',
  },
  noPrimaryCategoriesHeader: {
    id: `${scope}.noPrimaryCategoriesHeader`,
    defaultMessage: 'No {pluralPrimaryOrgCategoryLabel} to manage',
  },
  noPrimaryCategoriesContent: {
    id: `${scope}.noPrimaryCategoriesContent`,
    defaultMessage:
      'Report access is given per {singularSecondaryOrgCategoryLabel} within a {singularPrimaryOrgCategoryLabel}, and none have been added yet.',
  },
  secondaryCategoriesErrorHeader: {
    id: `${scope}.secondaryCategoriesErrorHeader`,
    defaultMessage: 'No {pluralSecondaryOrgCategoryLabel} to show',
  },
  secondaryCategoriesErrorContent: {
    id: `${scope}.secondaryCategoriesErrorContent`,
    defaultMessage:
      'Select "Try again" in the {pluralSecondaryOrgCategoryLabel} list to reload them, then manage report access here.',
  },
  noSecondaryCategoriesHeader: {
    id: `${scope}.noSecondaryCategoriesHeader`,
    defaultMessage: 'No {pluralSecondaryOrgCategoryLabel} to manage',
  },
  noSecondaryCategoriesContent: {
    id: `${scope}.noSecondaryCategoriesContent`,
    defaultMessage:
      'Report access is given per {singularSecondaryOrgCategoryLabel}, and this {singularPrimaryOrgCategoryLabel} has none.',
  },
})
